import { render, staticRenderFns } from "./TradeAccount.vue?vue&type=template&id=3598116e&scoped=true&lang=pug"
import script from "./TradeAccount.vue?vue&type=script&lang=js"
export * from "./TradeAccount.vue?vue&type=script&lang=js"
import style0 from "./TradeAccount.vue?vue&type=style&index=0&id=3598116e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3598116e",
  null
  
)

export default component.exports